// Navigation, role and seed-data references — mirrors priority-risk.html exactly.
import {
    LayoutDashboard, Briefcase, Building2, Users, TrendingUp, Globe2, FileCheck2,
    FolderOpen, Calendar, ClipboardList, CheckSquare, AlertTriangle, Building,
    Layers, ShieldCheck, Flame, MessageSquare, Check, FileText, PencilRuler,
    List, GraduationCap, Award, HardHat, Bot, Wand2, BookOpen, KeyRound,
    Activity, Settings, Sparkles, Plus, BarChart3, Workflow, CalendarDays, Truck, Cone, BadgeCheck, Gauge, Mail, Biohazard, Tags, Construction, Radar, ClipboardCheck,
} from "lucide-react";

export const NAV = [
    { group: null, items: [
        { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, module: "dashboard" },
        { id: "analytics", label: "Analytics", icon: BarChart3, module: "dashboard" },
    ] },
    {
        group: "Clients & Portals", items: [
            { id: "clients", label: "Clients", icon: Briefcase, module: "clients" },
            { id: "buildings", label: "Sites & Buildings", icon: Building, module: "buildings" },
            { id: "contacts", label: "Contacts", icon: Users, module: "contacts" },
            { id: "certificates", label: "Certificates", icon: BadgeCheck, module: "certificates" },
            { id: "pipeline", label: "Sales Pipeline", icon: TrendingUp, module: "pipeline" },
            { id: "portals", label: "Client Portals", icon: Globe2, module: "portals" },
            { id: "quotes", label: "Enquiries & Quotes", icon: FileCheck2, module: "quotes" },
        ],
    },
    {
        group: "Projects & Delivery", items: [
            { id: "projects", label: "Projects", icon: FolderOpen, module: "projects" },
            { id: "schedule", label: "Site Visits & Schedule", icon: Calendar, module: "schedule" },
            { id: "calendar", label: "Calendar", icon: CalendarDays, module: "calendar" },
            { id: "onsite", label: "On Site", icon: Radar, module: "inductions" },
            { id: "inspections", label: "Audits & Inspections", icon: ClipboardList, module: "inspections" },
            { id: "inductions", label: "Inductions", icon: ShieldCheck, module: "inductions" },
            { id: "clp", label: "CLP Tool", icon: Truck, module: "clp" },
            { id: "tmp", label: "Traffic Management Plan", icon: Cone, module: "tmp" },
            { id: "weekly-reports", label: "Weekly Site Reports", icon: ClipboardCheck, module: "weekly_reports" },
            { id: "actions", label: "Actions", icon: CheckSquare, module: "actions" },
        ],
    },
    {
        group: "Safety & Compliance", items: [
            { id: "incidents", label: "Accidents & Incidents", icon: AlertTriangle, module: "incidents" },
            { id: "bsc", label: "Building Safety Case", icon: Building2, module: "bsc" },
            { id: "goldenthread", label: "Golden Thread", icon: Layers, module: "goldenthread" },
            { id: "bsa", label: "BSA Compliance Register", icon: ShieldCheck, module: "bsa" },
            { id: "fire", label: "Fire Safety", icon: Flame, module: "fire" },
            { id: "residents", label: "Resident Engagement", icon: MessageSquare, module: "residents" },
            { id: "asbestos", label: "Asbestos Management", icon: Biohazard, module: "asbestos" },
            { id: "compliance", label: "Compliance Tracker", icon: Check, module: "compliance" },
        ],
    },
    {
        group: "Documents & Forms", items: [
            { id: "documents", label: "Document Library", icon: FileText, module: "documents" },
            { id: "reports", label: "Reports", icon: FileCheck2, module: "reports" },
            { id: "rams", label: "RAMS", icon: PencilRuler, module: "rams" },
            { id: "cpp", label: "CPP / PCI Plans", icon: Construction, module: "cpp" },
            { id: "templates", label: "Form Templates", icon: List, module: "templates" },
        ],
    },
    {
        group: "People & Training", items: [
            { id: "training", label: "Training Matrix", icon: GraduationCap, module: "training" },
            { id: "competency", label: "Competency", icon: Award, module: "competency" },
            { id: "contractors", label: "Contractors", icon: HardHat, module: "contractors" },
        ],
    },
    {
        group: "Beyond AI", icon: Sparkles, items: [
            { id: "ai-assist", label: "AI Assistant", icon: Bot, module: "ai" },
            { id: "ai-report", label: "AI Report Writer", icon: Wand2, module: "ai" },
            { id: "ai-kb", label: "Knowledge Base", icon: BookOpen, module: "ai" },
        ],
    },
    {
        group: null, items: [
            { id: "learning", label: "Help & Guides", icon: BookOpen, module: "learning" },
        ],
    },
    {
        group: "Admin", items: [
            { id: "users", label: "Users & Roles", icon: Users, module: "admin" },
            { id: "permissions", label: "Permissions", icon: KeyRound, module: "admin" },
            { id: "portal-presets", label: "Portal Module Presets", icon: Layers, module: "admin" },
            { id: "project-templates", label: "Project Templates", icon: Workflow, module: "admin" },
            { id: "project-types", label: "Project Types", icon: Tags, module: "admin" },
            { id: "service-types", label: "Service Types", icon: Tags, module: "admin" },
            { id: "fee-proposal-templates", label: "Fee Proposal Templates", icon: FileText, module: "admin" },
            { id: "folder-templates", label: "Folder Templates", icon: FolderOpen, module: "admin" },
            { id: "audit", label: "Audit Log", icon: Activity, module: "admin" },
            { id: "email-outbox", label: "Email Outbox", icon: Mail, module: "admin" },
            { id: "system-health", label: "System Health", icon: Gauge, module: "admin" },
            { id: "settings", label: "Settings", icon: Settings, module: "admin" },
        ],
    },
];

// Modules a client portal user actually sees (the rest are hidden in client view)
export const PORTAL_MODULES = new Set([
    "dashboard", "buildings", "projects", "schedule", "calendar", "inspections", "actions",
    "incidents", "safety-cross", "bsc", "goldenthread", "bsa", "fire", "residents", "compliance",
    "documents", "certificates", "reports", "clp", "tmp", "training", "competency", "contractors", "ai", "inductions",
    "rams", "learning",
]);

// Lean, task-first portal navigation (Phase 2). Used for site_manager / reviewer —
// a small flat set of destinations. "Daily site tasks" arrives in Phase 5.
export const PORTAL_NAV_SITE = [
    { id: "dashboard", label: "Daily site tasks", icon: ClipboardList, module: "dashboard" },
    { id: "onsite", label: "On Site", icon: Radar, module: "inductions" },
    { id: "projects", label: "Projects", icon: FolderOpen, module: "projects" },
    { id: "weekly-reports", label: "Weekly Site Report", icon: ClipboardCheck, module: "weekly_reports" },
    { id: "actions", label: "My actions", icon: CheckSquare, module: "actions" },
    { id: "documents", label: "Reports & documents", icon: FileText, module: "documents" },
    { id: "incidents", label: "Incidents", icon: AlertTriangle, module: "incidents" },
    { id: "asbestos", label: "Asbestos Management", icon: Biohazard, module: "asbestos" },
    { id: "fire", label: "Fire Safety", icon: Flame, module: "fire" },
    { id: "inductions", label: "Inductions", icon: ShieldCheck, module: "inductions" },
    { id: "rams", label: "RAMS", icon: PencilRuler, module: "rams" },
    { id: "calendar", label: "Calendar / visits", icon: CalendarDays, module: "calendar" },
    { id: "certificates", label: "Certificates", icon: BadgeCheck, module: "certificates" },
    { id: "learning", label: "Help & Guides", icon: BookOpen, module: "learning" },
];

// Client director / manager (client_admin) portal navigation — broader, client-wide
// visibility over projects, estate and company details. Still gated by portal_modules.
export const PORTAL_NAV_ADMIN = [
    { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, module: "dashboard" },
    { id: "analytics", label: "Analytics", icon: BarChart3, module: "dashboard" },
    { id: "onsite", label: "On Site", icon: Radar, module: "inductions" },
    { id: "projects", label: "Projects", icon: FolderOpen, module: "projects" },
    { id: "buildings", label: "Sites & Buildings", icon: Building, module: "buildings" },
    { id: "weekly-reports", label: "Weekly Site Reports", icon: ClipboardCheck, module: "weekly_reports" },
    { id: "actions", label: "Actions", icon: CheckSquare, module: "actions" },
    { id: "documents", label: "Reports & documents", icon: FileText, module: "documents" },
    { id: "incidents", label: "Incidents", icon: AlertTriangle, module: "incidents" },
    { id: "inductions", label: "Inductions", icon: ShieldCheck, module: "inductions" },
    { id: "rams", label: "RAMS", icon: PencilRuler, module: "rams" },
    { id: "calendar", label: "Calendar / visits", icon: CalendarDays, module: "calendar" },
    { id: "certificates", label: "Certificates", icon: BadgeCheck, module: "certificates" },
    { id: "compliance", label: "Compliance", icon: Check, module: "compliance" },
    { id: "training", label: "Training Matrix", icon: GraduationCap, module: "training" },
    { id: "asbestos", label: "Asbestos Management", icon: Biohazard, module: "asbestos" },
    { id: "fire", label: "Fire Safety", icon: Flame, module: "fire" },
    { id: "learning", label: "Help & Guides", icon: BookOpen, module: "learning" },
];

export const ROLE_LABELS = {
    director: "Priority Risk Director",
    administrator: "Priority Risk Administrator",
    consultant: "Priority Risk Consultant",
    client_admin: "Client Admin",
    site_manager: "Client Site Manager",
    reviewer: "View-Only / External Reviewer",
};

export const ROLE_COLOURS = {
    director: "var(--brand-accent, #C75A1B)",
    administrator: "#2A5DB0",
    consultant: "#3F7D3A",
    client_admin: "#6B4E9E",
    site_manager: "#C68A1C",
    reviewer: "#6F6A64",
};

export const STATUS_PILL = {
    green: { bg: "#E8F1E6", fg: "#3F7D3A" },
    amber: { bg: "#FCF1DC", fg: "#C68A1C" },
    red: { bg: "#FBE8E5", fg: "#B33A2E" },
    blue: { bg: "#E7EEF9", fg: "#2A5DB0" },
    purple: { bg: "#EEE9F6", fg: "#6B4E9E" },
    accent: { bg: "#FBEFE5", fg: "#9F4212" },
    neutral: { bg: "#F0EDE8", fg: "#6F6A64" },
};

export function pillForRisk(risk) {
    if (risk === "High") return "red";
    if (risk === "Medium") return "amber";
    if (risk === "Low") return "green";
    return "neutral";
}

export function pillForStatus(s) {
    const map = {
        Active: "green", Onboarding: "blue", Paused: "amber", Archived: "neutral",
        Enabled: "green", Disabled: "neutral", Linked: "blue", "N/A": "neutral",
    };
    return map[s] || "neutral";
}
